export default __webpack_public_path__ + "static/media/cottage_01.f06a76bd.webp";